export default __webpack_public_path__ + "static/media/award-1.e5aa9be4.png";